import {gql, useMutation} from "@apollo/client";

const ADD_TEAM_MUTATION = gql`
mutation AddTeam ($name: String!, $seasonId: Int!) {
  createTeam(name: $name, seasonId: $seasonId) {
    organization {
      id
      name
      slug
    }
  }
}
`;

export default function AddTeamMutation() {
    return useMutation(ADD_TEAM_MUTATION);
}